import track from './track';
import getProductData from './get-product-data';

/**
 * Track a product click event (basically whenever it will appear in an overlay)
 * @param {IProduct} product - product model
 */
export default function productClick(product) {
    return track({
        event: 'productClick',
        ecommerce: {
            actionField: { list: product.list },
            products: [getProductData(product)],
        },
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/product-click.js